import styled from 'styled-components'

const StyledEbestWebViewLayout = styled.div`
  background-color: var(--color-ebest-grayscale-gray50);

  /* 본문 기본 스타일 */
  font-size: var(--font-size-13);
  font-weight: 400;
  color: #444444;
  line-height: var(--spacing-legacy-18);
  letter-spacing: -0.5px;

  /* 제목 스타일 */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .mainTitle,
  .topic-title {
    font-size: var(--font-size-16);
    font-weight: 700;
    color: #000000;
    line-height: var(--spacing-legacy-24);
    letter-spacing: -0.5px;
  }

  > main {
    margin: auto;
    width: 40rem;
    min-height: 100vh;
    background-color: var(--color-ebest-primary-white);

    @media (max-width: 767px) {
      width: 100%;

      min-height: -moz-available;
      min-height: -webkit-fill-available;
      min-height: fill-available;
    }
  }

  // 텍스트 드래그 금지
  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`

export default StyledEbestWebViewLayout
